import { combineReducers } from 'redux';
import { items, itemsHasErrored, itemsIsLoading, itemSelected } from './items';

export default combineReducers({
    items,
    itemsHasErrored,
    itemsIsLoading,
    itemSelected
});


// WEBPACK FOOTER //
// ./src/reducers/index.js